<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
<!--                <form class="form-inline my-2 my-lg-0">-->
<!--                    <button-->
<!--                            class="btn btn-warning my-2 my-sm-0"-->
<!--                            type="button">-->
<!--                        <icon name="plus"></icon>-->
<!--                        เพิ่มกะการทำงาน-->
<!--                    </button>-->
<!--                </form>-->
            </div>
        </nav>

        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ตารางการทำงาน</th>
                    <th scope="col">เวลาทำงาน</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in shiftList">
                    <td>
                        {{data.name}}
                    </td>
                    <td>
                        <template v-if="data.shift_work_id == 1">
                            7.00 น. - 19.00 น.
                        </template>
                        <template v-else-if="data.shift_work_id == 2">
                            19.00 น. - 7.00 น.
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        name: "shift-list",
        created(){
            this.$store.dispatch("Common/setShiftWorkEmployee");
        },
        data(){
            return {
            }
        },
        computed:{
            ...mapState({
                shiftList:state=>{
                    return state.Common.shift_work_employee;
                },
            })
        },
    }
</script>

<style scoped>

</style>